// import React from "react";
import Modal from "react-modal";
import { FacebookShareButton, TwitterShareButton, WhatsappShareButton, EmailShareButton } from "react-share";
import { FaFacebookF, FaTwitter, FaWhatsapp, FaEnvelope, FaTimes } from "react-icons/fa";

Modal.setAppElement("#root");

const ShareModal = ({ isOpen, onClose, productUrl, productTitle }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Share Product"
      style={{
        content: {
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          padding: "20px",
          borderRadius: "12px",
          textAlign: "center",
          maxWidth: "350px", // Reduced size
          width: "90%",
          height:'110px',
          backgroundColor: "#ffffff",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
          border: "none",
        },
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.6)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
        },
      }}
    >
      {/* Close Button */}
      <button
        onClick={onClose}
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          background: "none",
          border: "none",
          cursor: "pointer",
          fontSize: "18px",
          color: "#555",
        }}
      >
        <FaTimes />
      </button>

      <h2 style={{ color: "#333", fontSize: "1.3em", fontWeight: "bold", marginBottom: "15px" }}>
        SHARE
      </h2>

      {/* Share Buttons */}
      <div style={{ display: "flex", justifyContent: "center", gap: "12px", marginBottom: "15px" }}>
        <FacebookShareButton url={productUrl} quote={productTitle}>
          <div className="social-icon bg-[#1877F2] hover:bg-[#165DB6]">
            <FaFacebookF size={24} color="blue" />
          </div>
        </FacebookShareButton>

        <TwitterShareButton url={productUrl} title={productTitle}>
          <div className="social-icon bg-[#1DA1F2] hover:bg-[#0D95E8]">
            <FaTwitter size={24} color="black" />
          </div>
        </TwitterShareButton>

        <WhatsappShareButton url={productUrl} title={productTitle}>
          <div className="social-icon bg-[#25D366] hover:bg-[#1EB254]">
            <FaWhatsapp size={24} color="green" />
          </div>
        </WhatsappShareButton>

        <EmailShareButton url={productUrl} subject={productTitle}>
          <div className="social-icon bg-[#D44638] hover:bg-[#B33C30]">
            <FaEnvelope size={24} color="red" />
          </div>
        </EmailShareButton>
      </div>

      <style>
        {`
          .social-icon {
            width: 50px;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            color: white;
            cursor: pointer;
            transition: background-color 0.3s ease, transform 0.2s ease;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
            overflow: visible; /* Ensure icon is visible */
          }

          .social-icon:hover {
            transform: scale(1.1);
          }
        `}
      </style>
    </Modal>
  );
};

export default ShareModal;
